<template>
    <v-container pa-0 ma-0 fluid>
        <v-flex>
            <v-img
                    dark
                    :src="require('@/assets/img/innovation/johannes-plenio-fmTde1Fe23A-unsplash_cutted.jpg')"
            >
                <v-layout fill-height class="align-center ma-4 pa-4" >
                    <v-flex xs12>
                        <div :class="isMobile() ? 'display-1 font-weight-bold white--text text-shadow': 'display-4 font-weight-bold white--text text-shadow'">
                            NTT DATA Discovery
                        </div>
                        <br/>
                        <div :class="isMobile() ? 'headline font-weight-bold white--text text-shadow': 'display-2 font-weight-bold white--text text-shadow'">
                            Startup Collaboration Platform
                        </div>

                    </v-flex>
                </v-layout>

            </v-img>
        </v-flex>

        <v-container grid-list-sm text-xs-left>
            <v-flex xs12 py-5>
                <span class="display-2">What does "innovation" mean to us?</span>
            </v-flex>
            <v-flex xs12 py-4>
                <span class="headline">

                    One of the goals of the Innovation organization is to contribute to the <strong>continuous improvement</strong>
                    of the offering towards our customers. In order to pursue this goal, we are actively searching for
                    <strong>innovative startups</strong> which can supply differential technologies and solutions to
                    deliver customer value, complementing the portfolio of our company.

                    <br>
                    <br>
                    <strong>Discovery</strong> creates value for all the involved parties: startups, NTT DATA customers and NTT DATA itself.
                    <br>
                    By registering to Discovery, startups will be visible to the NTT DATA Group and to the related Customers, thereby increasing their chances to create business.
                    <br>
                    <br>
                    <br>
                    <br>

                </span>

            </v-flex>
        </v-container>
    </v-container>

</template>


<script>
    import RouterService from "@/helpers/RouterService";
    import StateService from "@/helpers/StateService.js";
    import SettingsService from "@/helpers/SettingsService.js";


    export default {
        name: "LoginGhost",
        components: {},
        created(){
            StateService.resetAllVolatileData();
            SettingsService.save();
        },
        data() {
            return {
                hover:false,
                hover1:false,
                hover2:false,
            };
        },
        props: {
            isLogout: {
                type: Boolean,
                default: false,
            },
        },
        mounted() {
            if (this.isLogout) {
                StateService.resetUserInfoAndSettings();
            }
        },
        methods: {
            tabletAndDown() {
                return this.$vuetify.breakpoint.name === "xs" ||
                    this.$vuetify.breakpoint.name === "sm";
            },
            isMobile() {
                return this.$vuetify.breakpoint.name === "xs";
            },
            navigate(path) {
                RouterService.goTo(path);
            },
        },
    };
</script>

<style lang="scss">

    .text-shadow{
        text-shadow: 2px 2px 2px rgb(0, 0, 0);
    }

</style>
